import React, { ElementType } from 'react';
import { format, parseISO } from 'date-fns';
import {
  CellYesNoV8,
  TableCellV8,
  CellYesNoEngV8,
  CellDateTimeV8,
  CellDateV8,
  FieldCheckBox,
  FormCol2,
  FieldDatepicker,
  FormCol3,
} from 'motion-components';

export const isActiveField = (t, canEdit, as: ElementType<unknown> = 'div') => {
  return (
    <FieldCheckBox
      disabled={!canEdit}
      as={as}
      label={t('Ενεργή Εγγραφή')}
      name="isActive"
      onLabel={t('ΝΑΙ')}
      offLabel={t('ΟΧΙ')}
    />
  );
};

export const isPubliclyVisibleInMap = (t, canEdit) => {
  return (
    <FieldCheckBox
      disabled={!canEdit}
      as={'div'}
      label={t('Ορατό στον Χάρτη')}
      name="isPubliclyVisibleInMap"
      onLabel={t('ΝΑΙ')}
      offLabel={t('ΟΧΙ')}
    />
  );
};

export const isIdocMulti = (t, canEdit) => {
  return (
    <FieldCheckBox
      disabled={!canEdit}
      as={'div'}
      label={t('Σύνθετο Δρομολόγιο')}
      name="isMulti"
      onLabel={t('ΝΑΙ')}
      onStyle={'primary'}
      offLabel={t('ΟΧΙ')}
    />
  );
};

export const isCancelled = (t, canEdit) => {
  return (
    <FieldCheckBox
      disabled={!canEdit}
      as={'div'}
      label={t('Άκυρη Εγγραφή')}
      name="isCancelled"
      onLabel={t('ΝΑΙ')}
      onStyle={'primary'}
      offLabel={t('ΟΧΙ')}
    />
  );
};

export const dateField = (label, name, t, canEdit, as?, required = false) => {
  return (
    <FieldDatepicker
      as={as}
      label={label}
      name={name}
      showTimeSelect={false}
      dateFormat="d/M/yyyy"
      disabled={!canEdit}
      required={required}
    />
  );
};

export const dateTimeField = (label, name, t, canEdit) => {
  return (
    <FieldDatepicker
      label={label}
      name={name}
      showTimeSelect
      dateFormat="d/M/yyyy HH:mm"
      timeFormat="HH:mm"
      timeIntervals={15}
      disabled={!canEdit}
    />
  );
};

export function convertFieldToFloat(values: any, fieldnames: string[]) {
  fieldnames.forEach((element) => {
    if (values[element]) values[element] = parseFloat(values[element].toString());
    else if (values[element] === '') values[element] = null;
  });
}

export function convertFieldToInt(values: any, fieldnames: string[]) {
  fieldnames.forEach((element) => {
    if (values[element] && typeof values[element] !== 'number')
      values[element] = parseInt(values[element].toString());
    else if (values[element] === '') values[element] = null;
  });
}

// Converts nullable boolean-like fields into real booleans for mutations.
// Requirement: if the value is `null` or `undefined`, set it to `false`.
export function convertFieldToBoolean(values: any, fieldnames: string[]) {
  fieldnames.forEach((element) => {
    const v = values?.[element];
    console.log('$$$ convertFieldToBoolean v', element, v);
    if (v === null || v === undefined) {
      values[element] = false;
      return;
    }

    if (typeof v === 'string') {
      const normalized = v.trim().toLowerCase();
      if (normalized === 'true' || normalized === '1' || normalized === 'yes')
        values[element] = true;
      else if (normalized === 'false' || normalized === '0' || normalized === 'no')
        values[element] = false;
    }
  });
}
